export default {
	label: 'Audit',
	active: 'Käimasolev audit',
	name: 'Auditi nimi',
	finishedAudits: 'Lõpetatud auditid',
	finishDialog: {
		title: 'Kinnita lõpetamine',
		body: 'Lõpetatud auditit ei ole võimalik enam muuta. Kas soovite lõpetada "{auditName}" täiendamise?',
	},
	noActiveAudits: {
		header: 'Käimasolevad auditid puuduvad',
		body: 'Kasutajal puudub õigus alustada auditeid või lisada auditi kommentaare.',
	},
	foreignInternalComments: 'Väli siseaudiitori kommentaarid',
	comment: 'Audiitori kommentaar | Audiitori kommentaarid',
	addComment: 'Lisa auditi kommentaar',
	internalComments: 'Siseaudiitori kommentaarid',
	noComments: 'Kommentaarid puuduvad',
	type: 'Auditi tüüp',
	noAudit: 'Puudub',
	basicAudit: 'Audit',
	basicAbbr: 'A',
	foreignInternalAudit: 'Väline siseaudit',
	foreignInternalAbbr: 'VSA',
	internalAudit: 'Siseaudit',
	privateInternalAbbr: 'SA',
	publicInternalAbbr: 'ASA',
	startNew: 'Alusta uut auditit',
	new: 'Uus audit',
	confirmNew: 'Käimasolev audit saab lõpetatud. Soovid kindlasti alustada uut?',
	created: 'Uus audit on loodud',
	completed: 'Audit lõpetatud',
	addUserReply: 'Sisesta kasutaja vastus',
	basicAuditor: 'Audiitor',
	internalAuditor: 'Siseaudiitor',
	published: 'Audit avalikustatud',
	ok: 'Kontrollitud',
	remark: 'Tähelepanek',
	defect: 'Puudus',
	checks: 'Audiitori kontroll',
	noKind: 'Kommentaar',
	addThisToAudit: 'Lisa auditi valimisse',
	inAudit: 'On auditi valimis',
	empty: 'Tühjenda valim',
	emptied: 'Auditi valim tühjendatud',
	addToAudit: 'Lisa auditi valimisse',
	removeFromAudit: 'Eemalda auditi valimist',
	cantAdd: 'Uue auditi loomiseks vali esmalt asutus',
}
